var _ellipse, _ellipse2, _ellipse3, _ellipse4, _ellipse5, _ellipse6, _ellipse7, _ellipse8, _ellipse9, _ellipse0, _ellipse1, _ellipse10, _ellipse11, _path, _path2, _path3, _path4, _path5, _path6;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCancelRedeemSuccess(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 76,
    viewBox: "0 0 80 76",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 41.8725,
    cy: 38.1713,
    rx: 26.5532,
    ry: 26.7492,
    fill: "#42BE40",
    fillOpacity: 0.36
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 31.3944,
    cy: 2.92456,
    rx: 2.79867,
    ry: 2.81933,
    fill: "#3463AF"
  })), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 72.5101,
    cy: 21.0244,
    rx: 3.06383,
    ry: 3.08645,
    fill: "#3463AF"
  })), _ellipse4 || (_ellipse4 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 2.53289,
    cy: 39.0081,
    rx: 2.53289,
    ry: 2.55159,
    fill: "#3463AF"
  })), _ellipse5 || (_ellipse5 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 27.0013,
    cy: 69.6797,
    rx: 3.06383,
    ry: 3.08645,
    fill: "#3463AF"
  })), _ellipse6 || (_ellipse6 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 68.4252,
    cy: 56.9671,
    rx: 3.06383,
    ry: 3.08645,
    fill: "#3463AF"
  })), _ellipse7 || (_ellipse7 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 51.7449,
    cy: 67.6641,
    rx: 1.02128,
    ry: 1.02882,
    fill: "#3463AF"
  })), _ellipse8 || (_ellipse8 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 64.3406,
    cy: 17.938,
    rx: 1.02128,
    ry: 1.02882,
    fill: "#3463AF"
  })), _ellipse9 || (_ellipse9 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 74.5535,
    cy: 42.6296,
    rx: 1.02128,
    ry: 1.02882,
    fill: "#3463AF"
  })), _ellipse0 || (_ellipse0 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 12.2547,
    cy: 56.3472,
    rx: 1.02128,
    ry: 1.02882,
    fill: "#3463AF"
  })), _ellipse1 || (_ellipse1 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 21.7869,
    cy: 14.8516,
    rx: 1.02128,
    ry: 1.02882,
    fill: "#3463AF"
  })), _ellipse10 || (_ellipse10 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 56.4598,
    cy: 7.44996,
    rx: 1.02128,
    ry: 1.02882,
    fill: "#3463AF"
  })), _ellipse11 || (_ellipse11 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 12.2547,
    cy: 15.8804,
    rx: 1.02128,
    ry: 1.02882,
    fill: "#3463AF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M41.8719 55.3183C51.2724 55.3183 58.8931 47.6413 58.8931 38.1713C58.8931 28.7014 51.2724 21.0244 41.8719 21.0244C32.4713 21.0244 24.8506 28.7014 24.8506 38.1713C24.8506 47.6413 32.4713 55.3183 41.8719 55.3183Z",
    fill: "#42BE40"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M37.3992 45.3329L32.1703 39.7819C31.4545 39.0219 31.4956 37.8196 32.2618 37.1095C33.0279 36.3995 34.2401 36.4403 34.956 37.2002L38.9893 41.482L45.3735 35.5653C45.4309 35.5121 45.4909 35.4633 45.5529 35.4184L48.5551 32.6361C49.3213 31.9261 50.5336 31.9669 51.2494 32.7269C51.9652 33.4868 51.924 34.6892 51.1579 35.3993L41.9884 43.8973L41.9786 43.8869L38.8067 46.8265L37.3992 45.3329Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M41.5509 71.8314L42.4749 70.0647L43.5837 71.8314L45.6165 72.1847L43.9533 73.598L44.3229 75.8947L42.4749 74.8347L40.4421 75.8947L40.8117 73.598L39.1484 72.1847L41.5509 71.8314Z",
    fill: "#F0745C"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M3.13252 25.4618L3.81337 24.1108L4.63039 25.4618L6.12826 25.732L4.90273 26.8128L5.17507 28.569L3.81337 27.7585L2.3155 28.569L2.58784 26.8128L1.3623 25.732L3.13252 25.4618Z",
    fill: "#F0745C"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M42.9206 2.75584L43.5042 1.50879L44.2045 2.75584L45.4884 3.00525L44.438 4.00289L44.6714 5.62405L43.5042 4.87582L42.2203 5.62405L42.4538 4.00289L41.4033 3.00525L42.9206 2.75584Z",
    fill: "#F0745C"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M75.9347 32.4973L76.8587 30.6267L77.9675 32.4973L80.0003 32.8714L78.3371 34.3679L78.7067 36.7996L76.8587 35.6773L74.8258 36.7996L75.1954 34.3679L73.5322 32.8714L75.9347 32.4973Z",
    fill: "#F0745C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCancelRedeemSuccess);
export default __webpack_public_path__ + "static/media/CancelRedeemSuccess.66a1ef8d304721fd7ba0d015db43e175.svg";
export { ForwardRef as ReactComponent };